import { render } from "./MovieYouTube.vue?vue&type=template&id=0966517c&scoped=true"
import script from "./MovieYouTube.vue?vue&type=script&lang=js"
export * from "./MovieYouTube.vue?vue&type=script&lang=js"

import "./MovieYouTube.vue?vue&type=style&index=0&id=0966517c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0966517c"]])

export default __exports__